import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  titulo: Yup.string()
    .required("El título es requerido")
    .max(150, "Máximo 150 caracteres"),
  art: Yup.string().required("Requerido"),
  nroSiniestro: Yup.string().required("Requerido"),
  tipo: Yup.string().required("El tipo es requerido"),
  subtipo: Yup.string().required("La consulta es requerida"),
  mensaje: Yup.string()
    .required("El mensaje es requerido")
    .max(5000, "Máximo 5000 caracteres"),
});
